import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { parseTranslationKey } from '../helpers';
import type { TrackedTranslation } from '../types';

type UseTranslationDataResult = {
  translations: TrackedTranslation[];
};

export function useTranslationData(trackedKeys: string[]): UseTranslationDataResult {
  const [t] = useTranslation();

  const translations = useMemo<TrackedTranslation[]>(() => {
    return trackedKeys.map((fullKey) => {
      const { namespace, key } = parseTranslationKey(fullKey);
      const value = t(fullKey, { postProcess: [] });

      return {
        fullKey,
        namespace,
        key,
        value: typeof value === 'string' ? value : fullKey,
      };
    });
  }, [trackedKeys, t]);

  return {
    translations,
  };
}
